import React from "react";
import { toast } from "sonner";
export const JSONInspector = ({ value, dataTestId = "rl-json-inspector" }) => {
  const text = JSON.stringify(value ?? {}, null, 2);
  return (
    <div data-testid={dataTestId} className="rounded-md border border-slate-200 bg-slate-50">
      <div className="flex items-center justify-between border-b border-slate-200 px-3 py-1.5">
        <span className="text-[10px] uppercase tracking-wide text-slate-500">JSON</span>
        <button type="button" data-testid={`${dataTestId}-copy`}
          onClick={() => { navigator.clipboard?.writeText(text); toast.success("Copied"); }}
          className="rounded bg-slate-200 px-2 py-0.5 text-[10px] hover:bg-slate-300">Copy</button>
      </div>
      <pre className="max-h-96 overflow-auto p-3 text-[11px] leading-tight text-slate-800">{text}</pre>
    </div>
  );
};
export default JSONInspector;
